exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.detailEdit .el-dialog__body {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-align: start;\r\n      -ms-flex-align: start;\r\n          align-items: flex-start;\r\n  background-color: #f4f4f4;\n}\n.curreny {\r\n  width: 15px;\r\n  text-align: center;\n}\r\n", ""]);

// exports
